import { inject, Injector } from '@angular/core';

import { Subject } from 'rxjs';

import { UserProfileTab } from '@core/tellent-types';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

import { CurrentUserProfileDialogComponent } from './current-user-profile-dialog.component';

export function withCurrentUserProfileDialogOpener(profileCloseNotifier: Subject<any>) {
  const dialogSvc = inject(DialogService);

  return (analyticsContext: string, tab: `${UserProfileTab}`) => {
    const ref = dialogSvc.openCustom(
      CurrentUserProfileDialogComponent,
      {
        injector: Injector.create({
          providers: [],
        }),
        width: DialogWidth.Small,
        containerOptions: { fullscreenOnMobile: true },
      },
      {
        analyticsContext,
        tab,
      },
    );

    ref.afterClosed.subscribe(event => {
      profileCloseNotifier.next(event);
    });

    return ref;
  };
}
